import { useCurrentView } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
export { useIsCurrentViewReadOnly, useGetSaveAsNewViewProps, useCurrentViewFilters } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
export default useCurrentView;